import { SharedModels } from '@project44-models/iam-gateway';

import { Exception } from '../../../../shared/abstract/domain/Exception';

export class UnknownUnifiedRoleException extends Exception {
  constructor(
    public readonly unknownUnifiedRole?: SharedModels.UnifiedRoleViewModel,
  ) {
    super(`Unknown UnifiedRole found: ${unknownUnifiedRole}'`);
  }

  public static throw(
    unknownUnifiedRole?: SharedModels.UnifiedRoleViewModel,
  ): never {
    throw new UnknownUnifiedRoleException(unknownUnifiedRole);
  }
}
